module.exports = __webpack_public_path__ + "img/Frente-77-00 off.7f49ea58.png";